import { Navigate } from 'react-router-dom';
import { requireModule } from '../../auth/guards';
import { MODULES } from '../../auth/permissions';
import CompanyMasterPage from './pages/CompanyMasterPage';
import ContactMastersPage from './pages/ContactMastersPage';
import DepartmentsPage from './pages/DepartmentsPage';
import EmployeeRecordsPage from './pages/EmployeeRecordsPage';
import ReferenceDataPage from './pages/ReferenceDataPage';
import RolesPage from './pages/RolesPage';
import UsersPage from './pages/UsersPage';

export const adminRoutes = [
  // The old admin/HR dashboard; its figures now live on the module dashboards, so old links land on Home.
  { path: '/dashboard', element: <Navigate to='/' replace /> },
  {
    path: '/departments',
    element: <DepartmentsPage />,
    handle: { breadcrumb: 'Departments' },
    loader: requireModule(MODULES.DEPARTMENTS),
  },
  {
    path: '/roles',
    element: <RolesPage />,
    handle: { breadcrumb: 'Roles & Menu Access' },
    loader: requireModule(MODULES.ROLES),
  },
  {
    path: '/users',
    element: <UsersPage />,
    handle: { breadcrumb: 'Users' },
    loader: requireModule(MODULES.USERS),
  },
  {
    path: '/reference-data',
    element: <ReferenceDataPage />,
    handle: { breadcrumb: 'Reference Data' },
    loader: requireModule(MODULES.REFERENCE_DATA),
  },
  {
    path: '/contact-masters',
    element: <ContactMastersPage />,
    handle: { breadcrumb: 'Contact Masters' },
    loader: requireModule(MODULES.CONTACT_MASTERS),
  },
  {
    path: '/company-master',
    element: <CompanyMasterPage />,
    handle: { breadcrumb: 'Company Master' },
    loader: requireModule(MODULES.COMPANY_MASTER),
  },
  {
    path: '/employee-records',
    element: <EmployeeRecordsPage />,
    handle: { breadcrumb: 'Employee Records' },
    loader: requireModule(MODULES.EMPLOYEES),
  },
];
